import { RouteComponentProps } from "@reach/router";
import Layout from "../layout/Layout";
import List from "../List/List";
import { EntityNames } from "../../../enums/EntityNames";
import { EntityViewTypes } from "../../../enums/EntityViewTypes";


export default function WorkstationsPage(props: RouteComponentProps) {
    return (
        <Layout pageTitle="Workstations" showBackButton={false} showBreadcrumb={false} canScroll={true}>
            <List parentEntityName={undefined}
                entityId={''}
                entityName={EntityNames.workstations}
                enableFilters={false}
                searchType={EntityViewTypes.list}
                canAdd={false}
                tabView={false} />
        </Layout>
    )

}